export default () => ({
  checked: null,
  timer: null,

  init() {
    CF.customerReady(
      function () {
        const accept = CF.customer.get("accepts_marketing");
        document.getElementById("newsletterConsent").checked = accept;
        this.checked = accept;
      }.bind(this)
    );
  },
  toggleConsent() {
    this.checked = !this.checked;
    clearTimeout(this.timer); // Reset the timer
    this.timer = setTimeout(
      function () {
        CF.customerReady(
          function () {
            CF.customer.update({
              accepts_marketing: this.checked,
            });
          }.bind(this)
        );
      }.bind(this),
      1000
    );

    fetch(`${shopUrl}/apps/jl-api/frontend/voyado/contact`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: {
          preferences: {
            acceptsEmail: this.checked,
          },
        },
      }),
    })
      .then((response) => {
        //return response.json();
      })
      .then((response) => {
        //console.log(response);
      });
  },
});
